import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38aa90e1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "name-wrapper"
};
const _hoisted_2 = {
  class: "d-flex align-items-center"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.item.icon,
    alt: $props.item.name
  }, null, 8, _hoisted_3), _createTextVNode(" " + _toDisplayString($props.item.name) + " ", 1), _hoisted_4])]);
}